import { useQuery } from '@tanstack/react-query';
import {
  getApplicationFormDetails,
  getApplications,
  getResourceFiles,
} from 'api/Rover/ApplicationForm';
import { RoverReactQueryKey } from 'constants/ReactQueryKeys';
import { QueryParamsInterface } from 'types/Shared';

interface IApplicationFormHookProps {
  formId: string;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useApplicationForm = ({
  formId,
  onSuccess,
  onError,
}: IApplicationFormHookProps) => {
  return useQuery(
    [RoverReactQueryKey.GET_APPLICATION_FORM_DETAILS],
    () => getApplicationFormDetails({ applicationFormId: formId }),
    {
      onSuccess,
      onError,
      enabled: !!formId,
    }
  );
};

interface IApplicationsHookProps {
  formId: string;
  params?: QueryParamsInterface;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useApplications = ({
  formId,
  params,
  onSuccess,
  onError,
}: IApplicationsHookProps) => {
  return useQuery(
    [RoverReactQueryKey.GET_APPLICATIONS, { formId, ...params }],
    () => getApplications({ params: { formId, ...params } }),
    {
      onSuccess,
      onError,
    }
  );
};

interface IResourceHookProps {
  formId: string;
  params?: QueryParamsInterface;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useResource = ({
  formId,
  params,
  onSuccess,
  onError,
}: IResourceHookProps) => {
  return useQuery(
    [RoverReactQueryKey.GET_RESOURCE, { formId, ...params }],
    () => getResourceFiles({ applicationFormId: formId, params }),
    {
      onSuccess,
      onError,
    }
  );
};
